import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useRegistrationStore, {
  RegistrationTrack,
} from '@/hooks/useRegistrationStore';
import { KIT_ID } from '@/config/routing/queryParams/registration';

const useRegistration = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    kitId,
    setKitId,
    initialized,
    initialize,
    setRestrictedRegistrationSteps,
  } = useRegistrationStore();

  const navigateWithParams = (path: string) => {
    const queryParams = new URLSearchParams({
      [KIT_ID]: kitId || '',
    });

    navigate(`${path}?${queryParams.toString()}`);
  };

  useEffect(() => {
    if (!initialized) {
      const queryParams = new URLSearchParams(location.search);
      const initialState = { kitId: queryParams.get(KIT_ID) ?? '' };
      initialize(initialState);
      setRestrictedRegistrationSteps([
        RegistrationTrack.ContactInformation,
        RegistrationTrack.PersonalInformation,
        RegistrationTrack.AccountCreation,
        RegistrationTrack.AddressConfirmation,
        RegistrationTrack.RegistrationConfirmation,
        RegistrationTrack.TermsOfService,
        RegistrationTrack.ConsentForm,
      ]);
    }
  }, [initialize, initialized, location.search]);

  return {
    kitId,
    setKitId,
    navigateWithParams,
  };
};

export default useRegistration;
